export default "__VITE_ASSET__CyGhqdlF__"